var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Data Science"}},[_c('app-echart-stacked-area',{attrs:{"option-data":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }